import { createFileRoute } from '@tanstack/react-router';
import { WaitlistSignup } from '@/components/waitlist/waitlist-signup';

export const Route = createFileRoute('/_neutral/waitlist')({
  component: RouteComponent,
});

const backgroundStyle = `
  .bg-pattern {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
      linear-gradient(to right, rgba(255,255,255,0.02) 1px, transparent 1px),
      linear-gradient(to bottom, rgba(255,255,255,0.02) 1px, transparent 1px);
    background-size: 20px 20px;
    pointer-events: none;
    z-index: 1;
  }

  .content {
    position: relative;
    z-index: 2;
  }
`;

function RouteComponent() {
  return (
    <main
      className="min-h-screen flex items-center justify-center"
      style={{
        background: 'radial-gradient(circle at center, hsl(var(--primary)/0.8), hsl(var(--primary-dark)/0.95))',
      }}
    >
      <style>{backgroundStyle}</style>
      <div className="bg-pattern"></div>
      <div className="content w-full">
        <WaitlistSignup />
      </div>
    </main>
  );
}
